import React from 'react'
import Font from '@cred/react-font'
import { Testable } from '@cred/react-testable'
import { Disclosure } from '@cred/react-disclosures-sdk'
import styles from './styles.scss'

const Disclosures = () => {
  const dateToday = new Date(),
    dateTodayFormatted = `${
      dateToday.getMonth() + 1
    }/${dateToday.getDate()}/${dateToday.getFullYear()}`

  return (
    <div className={styles.disclosureContainer}>
      <Testable className={styles.disclosure} testId="disclosure-content">
        <Font element="div" color="lighter" type="bodySmall" className={styles.disclosureContent}>
          <Disclosure required={false} slug="partners-widgets.mortgage-combined.disclosures" variables={{ dateTodayFormatted }} />
        </Font>
        <Font element="div" color="lighter" type="bodySmall">
          <Disclosure required={false} slug="mortgages.rates-page.nmls-number" />
        </Font>
      </Testable>
    </div>
  )
}

export default Disclosures
